/**
 * I passi del tutorial guidato di Incoming/Outcoming > Carico.
 *
 * Nessun preparativo: la pagina non ha menu ne' dialog da aprire, quindi non
 * serve nemmeno un `onStop` che la rimetta a posto.
 *
 * Tutto quello che sta sotto il campo del lettore compare solo dopo una lettura
 * andata a buon fine. Finche' non si e' scansionato nulla quei passi si
 * agganciano in basso e raccontano lo stesso cosa ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-incoming"] [data-tour="${name}"]`;

export function createWarehouseIncomingTourSteps() {
	return [
		{
			body: "Questa e' la pagina della merce che entra: si scansiona e la giacenza sale di uno. E' pensata per chi sta scaricando un bancale con il lettore in mano, non per correggere i numeri - per quello ci sono Inventario, che sostituisce il conteggio, e Ddt, che carica una bolla intera.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Un pezzo dentro per ogni lettura',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Punta e spara, il codice arriva da solo. Il campo e' in sola lettura apposta - ci compare l'ultimo codice letto, ma non si scrive a mano.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Come si legge un codice',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. Il codice inviato fa esattamente quello che fa la pistola: carica un pezzo.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Attenzione a questo, perche' e' il punto che sorprende: quando il codice corrisponde a una sola variante il carico e' gia' fatto nel momento in cui compare la riga verde. Non c'e' un pulsante da premere e non c'e' un annulla. Leggere due volte lo stesso codice carica due pezzi - il che e' comodo quando ne stai contando venti, meno quando la pistola fa doppio scatto.",
			key: 'done',
			placement: 'top',
			target: at('done'),
			timeout: 250,
			title: "Il carico e' immediato",
		},
		{
			body: "La riga mostra cosa hai caricato: foto, nome, sku ed ean, le caratteristiche della variante e la quantita' a magazzino gia' aggiornata. E' il modo per controllare a colpo d'occhio di aver letto il prodotto giusto. Se il codice non corrisponde a nulla, al suo posto compare un avviso rosso e non viene caricato niente.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			timeout: 250,
			title: 'Cosa hai appena caricato',
		},
		{
			body: "Puo' capitare che lo stesso codice stia su piu' varianti: in quel caso il sistema non sceglie per te e non carica niente. Compaiono tutte le candidate, ognuna con due pulsanti - EAN e SKU - e il carico parte solo quando indichi tu quale delle due letture vale. E' l'unico caso in cui questa pagina chiede una conferma.",
			key: 'choose',
			placement: 'left',
			target: at('choose'),
			timeout: 250,
			title: "Quando il codice e' ambiguo",
		},
	];
}
